var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.793 3.83732C16.793 3.51166 16.529 3.24767 16.2034 3.24767L12.2024 3.06707C11.8659 3.05188 11.5848 3.32057 11.5848 3.65738C11.5848 3.97187 11.8311 4.23125 12.1452 4.2475L14.8243 4.38614L9.95092 9.25952C9.72064 9.48979 9.72064 9.86315 9.95092 10.0934C10.1812 10.3237 10.5545 10.3237 10.7848 10.0934L15.6549 5.22333L15.7932 7.89549C15.8094 8.20956 16.0688 8.45587 16.3833 8.45587C16.7201 8.45587 16.9888 8.17478 16.9736 7.83831L16.793 3.83732Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93333 6.13335C4.52832 6.13335 4.2 6.46167 4.2 6.86668V15.4C4.2 15.805 4.52832 16.1334 4.93333 16.1334H13.4667C13.8717 16.1334 14.2 15.805 14.2 15.4V10.3334C14.2 10.002 14.4686 9.73335 14.8 9.73335C15.1314 9.73335 15.4 10.002 15.4 10.3334V15.4C15.4 16.4678 14.5344 17.3334 13.4667 17.3334H4.93333C3.86558 17.3334 3 16.4678 3 15.4V6.86668C3 5.79893 3.86558 4.93335 4.93333 4.93335H10.1333C10.4647 4.93335 10.7333 5.20198 10.7333 5.53335C10.7333 5.86472 10.4647 6.13335 10.1333 6.13335H4.93333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.21bb812b7436a075e13e7c1378cd66cd.svg";
export { ForwardRef as ReactComponent };